import { EditNewFormSection } from "components/MainSectionTemplate/types";
import { useDocumentV1Form } from "documentV1/hooks";
import { getInvoiceV1FormSections } from "invoice/getInvoiceV1FormSections";
import { DocumentTypeWithoutInvoice } from "utilities/documentUtils";

type InvoiceV1NewFormHook = ReturnType<typeof useDocumentV1Form>;

interface Config {
  documentType: DocumentTypeWithoutInvoice;
  displayDraft?: boolean;
  displayBookkeeping?: boolean;
  displayContact?: boolean;
  alwaysShowCurrency?: boolean;
}

const defaultConfig: Required<Config> = {
  documentType: "contract",
  displayDraft: true,
  displayBookkeeping: true,
  displayContact: true,
  alwaysShowCurrency: false,
}

export const getDocumentV1FormSections = (hook: InvoiceV1NewFormHook, initialConfig: Config): EditNewFormSection => {
  const config = {
    ...defaultConfig,
    ...initialConfig,
  };

  const { displayDraft, ...rest } = config;
  const title = site.currentEnvironment[config.documentType].newLabel;

  return getInvoiceV1FormSections(hook, {
    concerningLabel: RESX.Document.Subject,
    draftLabel: RESX.DocumentLifeCycle.Draft,
    displayCostCenter: false,
    displayBankAccount: false,
    displayProforma: displayDraft,
    title,
    displayArtistRider: config.documentType === "contract",
    ...rest,
  });
};

